import {
  useReviewsHoldoutGatedAssignSettingEffect,
  useReviewsHoldoutGatedSetting,
} from "@faire/deprecated-retailer-visitor-shared/settings/useReviewsHoldoutGatedSetting";
import { ENABLE_PRODUCT_REVIEW_RETAILER_DISPLAY_XP_V2_250627 } from "@faire/web-api--source/indigofair/settings/ENABLE_PRODUCT_REVIEW_RETAILER_DISPLAY_XP_V2_250627";

export const useSettingProductReviewRetailerDisplayXP = () =>
  useReviewsHoldoutGatedSetting(
    ENABLE_PRODUCT_REVIEW_RETAILER_DISPLAY_XP_V2_250627,
    false
  );

export const useAssignSettingProductReviewRetailerDisplayXPEffect = (
  additionalConditionsForAssignmentMet: boolean = true
) =>
  useReviewsHoldoutGatedAssignSettingEffect(
    ENABLE_PRODUCT_REVIEW_RETAILER_DISPLAY_XP_V2_250627,
    additionalConditionsForAssignmentMet
  );
